<template>
  <div class="flex flex-col">
    <div
      class="flex flex-col lg:flex-row w-full mx-auto items-stretch justify-stretch"
      style="min-height:calc(100vh - 64px);max-width:2048px;"
    >
      <div class="px-4 sm:px-8 xl:pr-16 flex flex-col flex-1 py-6 text-center
    items-center justify-center">
        <div class="max-w-xl">
          <h1 class="text-3xl leading-10 font-extrabold tracking-tight text-gray-900 sm:text-4xl
          sm:leading-10">
            Explore <span class="text-green-500">student loan rates</span> that others are getting!
          </h1>
          <p class="mt-4 text-left text-base sm:text-lg leading-7 text-gray-500">
            We’ve heard many requests to bring transparency to the student loan experience.
          </p>
          <p class="mt-4 text-left text-base sm:text-lg leading-7 text-gray-500">
            So we built this comparison tool where anyone can submit quotes anonymously,
            and see what others are getting.
          </p>
          <h2 class="mt-4 text-left text-base sm:text-lg leading-6 font-medium text-gray-900 mb-5">
            Together, we can bring transparency to the student loan application process.
          </h2>
          <div class="flex flex-row flex-wrap mt-10 w-full sm:-mx-2">
            <div class="rounded-md px-2 w-full sm:w-1/2 mb-4 sm:mb-0">
              <router-link
                :to="{name:'browse.quotes'}"
                class="w-full flex items-center justify-center px-2 py-3 border border-transparent
             text-base leading-6 font-medium rounded-md text-white bg-green-600 hover:bg-green-400
             focus:outline-none focus:border-green-500 focus:shadow-outline-green transition
             duration-150 ease-in-out md:py-4 md:text-lg">
                Browse Quotes
              </router-link>
            </div>
            <div class="rounded-md px-2 w-full sm:w-1/2">
              <router-link
                :to="{name:'share.quotes'}"
                class="w-full flex items-center justify-center px-2 py-3 border border-green-700
              text-base leading-6 font-medium rounded-md text-green-600 bg-white
              hover:text-green-700 hover:bg-gray-100 focus:outline-none focus:shadow-outline-green
              transition duration-150 ease-in-out md:py-4 md:text-lg"
              >
                Share Your Quote
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div
        class="header-image flex flex-col bg-black lg:flex-1 py-6 bg-cover"
        style="min-height:200px;"
      >

      </div>
    </div>
    <div class="flex flex-row mt-12">
      <div class="max-w-screen-xl mx-auto w-full pt-12 pb-16 px-4 sm:px-6 lg:px-8">
        <h2 class="text-3xl leading-9 font-extrabold text-gray-900">
          Frequently asked questions
        </h2>
        <div class="mt-6 border-t-2 border-gray-100 pt-10">
          <div class="flex flex-row flex-wrap sm:-mx-5">
            <div class="flex flex-col w-full sm:w-1/2 sm:px-5 py-5">
              <dt class="text-lg leading-6 font-medium text-gray-900">
                Where is this data coming from?
              </dt>
              <dd class="mt-2">
                <p class="text-base leading-6 text-gray-500">
                  Thanks to our community of thousands of members, we’ve received these
                  anonymized submissions of loan rates. Some of these submissions have been
                  vetted through screenshot verification. They are marked with a green check
                  sign.
                </p>
              </dd>
            </div>
            <div class="flex flex-col w-full sm:w-1/2 sm:px-5 py-5">
              <dt class="text-lg leading-6 font-medium text-gray-900">
                How is my information going to be protected?
              </dt>
              <dd class="mt-2">
                <p class="text-base leading-6 text-gray-500">
                  We do not publish any personal information when you submit your quotes,
                  and everything is anonymized.
                </p>
              </dd>
            </div>
            <div class="flex flex-col w-full sm:w-1/2 sm:px-5 py-5">
              <dt class="text-lg leading-6 font-medium text-gray-900">
                How do we verify the quotes we are receiving?
              </dt>
              <dd class="mt-2">
                <p class="text-base leading-6 text-gray-500">
                  We do have systems in place to prevent abuse of our product, but students and
                  families provide us a screenshot of quotes they received from the lenders
                  which we use to verify the quote.
                </p>
              </dd>
            </div>
            <div class="flex flex-col w-full sm:w-1/2 sm:px-5 py-5">
              <dt class="text-lg leading-6 font-medium text-gray-900">
                Why should I add a quote?
              </dt>
              <dd class="mt-2">
                <p class="text-base leading-6 text-gray-500">
                  Together, we can bring transparency to a system that needs it! By sharing
                  your quote, you’ll help the community get a better sense of the expected rates.
                </p>
              </dd>
            </div>
            <div class="flex flex-col w-full sm:w-1/2 sm:px-5 py-5">
              <dt class="text-lg leading-6 font-medium text-gray-900">
                Have a feature or filter request you would like to see?
              </dt>
              <dd class="mt-2">
                <p class="text-base leading-6 text-gray-500">
                  Email us here:
                  <a
                    class="text-green-500 underline"
                    target="_blank"
                    rel="noreferrer noopener"
                    href="mailto:questions@joinjuno.com?subject=Question%20Regarding%20JoinJuno.com"
                  >
                    questions@joinjuno.com
                  </a>
                </p>
              </dd>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-row mt-6">
      <div class="max-w-screen-xl mx-auto w-full pt-12 pb-16 px-4 sm:px-6 lg:px-8">
        <div class="mt-6 border-t-2 border-gray-100 pt-10">
          <div class="flex flex-col sm:flex-row flex-wrap sm:-mx-5">
            <div class="flex flex-col w-full sm:w-1/2 sm:p-5">
              <h2 class="text-2xl leading-8 font-extrabold text-gray-900 sm:text-3xl sm:leading-9">
                Get in touch
              </h2>
            </div>
            <div class="flex flex-col w-full sm:w-1/2 sm:px-5 py-5">
              <div>
                <h4 class="text-lg leading-6 font-medium text-gray-900">
                  We would love to hear from you:
                </h4>
                <dl class="mt-2 text-base leading-6 text-gray-500">
                  <div>
                    <dt class="sr-only">
                      Email
                    </dt>
                    <dd>
                      <a
                        class="text-green-500 underline"
                        target="_blank"
                        rel="noreferrer noopener"
                        href="mailto:questions@joinjuno.com?subject=Question%20Regarding%20JoinJuno.com"
                      >
                        questions@joinjuno.com
                      </a>
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingPage',
};
</script>

<style lang="scss">
  .header-image {
    background-image:url(../assets/img/header-small.jpg);
    @screen sm {
      background-image:url(../assets/img/header-medium.jpg);
    }
    @screen md {
      background-image:url(../assets/img/header-large.jpg);
    }
  }
</style>
